import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

export const backOfficeGuard: CanActivateFn = () => {
  const role = inject(AuthService).currentUser()?.role;
  if (
    role === 'staff' ||
    role === 'prosecutor' ||
    role === 'super_admin' ||
    role === 'admin' ||
    role === 'admin_bapas' || role === 'admin_kepala_lapas' || role === 'admin_kanwil' || role === 'admin_dapur' ||
    role === 'admin_health' ||
    role === 'admin_marketplace' ||
    role === 'admin_koperasi' ||
    role === 'admin_pengaduan' ||
    role === 'admin_integrasi' ||
    role === 'admin_kunjungan'
  )
    return true;
  inject(Router).navigate(['/login']);
  return false;
};
